import React from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'
import Hydrodtls from '../MenserviceHydro/Hydrodtls'
import Footer from '../Footer/Main'
import ExecutiveSearch from '../ExecutiveSearch/ExecutiveSearch'

function Main() {
    return (
        <>
            <div className="page-wrapper">
                <Header />
                <Breadcrumb subtitle="Home" title="Executive Search" />
                <ExecutiveSearch />
                <Footer />
            </div>
        </>
    )
}

export default Main